export enum CampaignTemplate {
  Zero = '0',
  One = '1'
}
